module.exports = __webpack_public_path__ + "static/media/icon-info-grey.91a9e810.svg";